module.exports = __webpack_public_path__ + "files/87efaaaba8e4e4923cde906fc61985e7.png";